"use strict";

var _require = require("abab"),
  atob = _require.atob;
exports.stripLeadingAndTrailingASCIIWhitespace = function (string) {
  return string.replace(/^[\t\n\f\r ]+/, "").replace(/[\t\n\f\r ]+$/, "");
};
exports.isomorphicDecode = function (input) {
  return Array.from(input, function (_byte) {
    return String.fromCodePoint(_byte);
  }).join("");
};
exports.forgivingBase64Decode = function (data) {
  var asString = atob(data);
  if (asString === null) {
    return null;
  }
  return Uint8Array.from(asString, function (c) {
    return c.codePointAt(0);
  });
};